import React from "react"

import { Button, ButtonProps, Spinner } from "react-bootstrap"

interface ActionButtonProps extends ButtonProps {
  spin?: boolean
  disableOnSpin?: boolean
  children?: React.ReactNode
}

function ActionIconButton({
  spin = false,
  disableOnSpin = false,
  children = null,
  className,
  disabled,
  ...buttonProps
}: ActionButtonProps) {
  const actualDisabled = disabled || (disableOnSpin && spin)
  const actualClassName = `${className || ""} btn-icon-action`

  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <Button {...buttonProps} className={actualClassName} disabled={actualDisabled}>
      {!spin ? children : <Spinner animation="border" size="sm" variant="link" className="ml-1" />}
    </Button>
  )
}

export default ActionIconButton
